import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import MemberService from "./memberService";


export const getMembers = createAsyncThunk("Member/get-Members", async (token,thunkAPI) => {
  try {
    return await MemberService.getMembers(token);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createMember = createAsyncThunk(
  "Member/create-Members",
  async (AssociationData, thunkAPI) => {
    try {
      return await MemberService.createMember(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
export const createMemberbulk = createAsyncThunk(
  "Member/create-Members-bulk",
  async (AssociationData, thunkAPI) => {
    try {
      return await MemberService.createMemberbulk(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getMember = createAsyncThunk(
  "Member/get-Member",
  async (id, thunkAPI) => {
    try {
      return await MemberService.getMember(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateMember = createAsyncThunk(
  "Member/update-Member",
  async (id, thunkAPI) => {
    try {
      return await MemberService.updateMember(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteMember = createAsyncThunk(
  "Member/delete-Member",
  async (id, thunkAPI) => {
    try {
      return await MemberService.deleteMember(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  Members: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const AssociationSlice = createSlice({
  name: "Member",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMembers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMembers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.Members = action.payload.data;
      })
      .addCase(getMembers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createMember.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createMember.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdMember = action.payload;
      })
      .addCase(createMember.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })
      .addCase(createMemberbulk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createMemberbulk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdMemberbulk = action.payload;
      })
      .addCase(createMemberbulk.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })






      .addCase(getMember.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMember.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.isError = false;
        state.isSuccess = true;
        state.memberemail= action.payload.data.email;
        state.membername= action.payload.data.name;
        state.memberpassword= action.payload.data.password;
      })
      .addCase(getMember.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateMember.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateMember.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedMember = action.payload;
      })
      .addCase(updateMember.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteMember.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteMember.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedMember = action.payload;
      })
      .addCase(deleteMember.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default AssociationSlice.reducer;
